module.exports = __webpack_public_path__ + "img/dark.10fc0385.svg";